import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_ENDPOINT;


const ContactHandler = {

    async doHandelContact(payload) {
        try {
            const { data } = await axios.post(`${BASE_URL}auth/contact`, payload);
            return data;
        } catch (error) {
            return error;
        }
    },
}

export default ContactHandler